import React from "react";
import DDApprovalComponent from "./DDApprovalComponent";
import KYCApprovalComponent from "./KYCApprovalComponent";
interface DemandDraftApprovalComponentProps {
  data: any;
  encryptedKey: string;
}

export default function DemandDraftApprovalWrapper({
  data,
  encryptedKey,
}: DemandDraftApprovalComponentProps) {
  const { request_type } = data ?? {};

  return (
    <div className="w-full my-4">
      {request_type === "payment" && (
        <DDApprovalComponent data={data} encryptedKey={encryptedKey} />
      )}
      {request_type === "kyc" && (
        <KYCApprovalComponent data={data} encryptedKey={encryptedKey} />
      )}
      {request_type !== "payment" && request_type !== "kyc" && (
        <div>Not found correct request type</div>
      )}
    </div>
  );
}
